import React, { Component } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Collapse,
  Fade,
  Row
} from "reactstrap";

class Collapses extends Component {
  constructor(props) {
    super(props);
    this.onEntering = this.onEntering.bind(this);
    this.onEntered = this.onEntered.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleAccordion = this.toggleAccordion.bind(this);
    this.toggleCustom = this.toggleCustom.bind(this);
    this.toggleFade = this.toggleFade.bind(this);
    this.state = {
      collapse: false,
      accordion: [true, false, false],
      custom: [true, false],
      status: "Closed",
      fadeIn: true,
      timeout: 300
    };
  }

  onEntering() {
    this.setState({ status: "Opening..." });
  }

  onEntered() {
    this.setState({ status: "Opened" });
  }

  onExiting() {
    this.setState({ status: "Closing..." });
  }

  onExited() {
    this.setState({ status: "Closed" });
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  toggleAccordion(tab) {
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));

    this.setState({
      accordion: state
    });
  }

  toggleCustom(tab) {
    const prevState = this.state.custom;
    const state = prevState.map((x, index) => (tab === index ? !x : false));

    this.setState({
      custom: state
    });
  }

  toggleFade() {
    this.setState({ fadeIn: !this.state.fadeIn });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xl="12" className="p-0">
            <div>
              {/* <CardHeader>
                <i className="fa fa-align-justify"></i> Collapse{" "}
                <small>accordion</small>
                <div className="card-header-actions">
                  <Badge>NEW</Badge>
                </div>
              </CardHeader> */}

              <div id="accordion">
                <div>
                  <CardHeader id="1" style={{ backgroundColor: "lightgrey" }}>
                    <Button
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      //   onClick={() => this.toggleAccordion(0)}
                      //   aria-expanded={this.state.accordion[0]}
                      aria-controls="collapseOne"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <Row className="justify-content-around text-center ">
                        <Col xs="1">S.No.</Col>
                        <Col xs="1">Booking ID</Col>
                        <Col xs="2">Name of Service Booked</Col>
                        <Col xs="2">Booking Date and Time</Col>
                        <Col xs="3">Date & Time of Service</Col>
                        <Col xs="1">Mode of Service</Col>
                        <Col xs="1">Current Status</Col>
                        <Col xs="1">
                          <i class="fa fa-folder-open-o" aria-hidden="true"></i>
                        </Col>
                      </Row>
                    </Button>
                  </CardHeader>
                  {/* <Collapse
                    isOpen={this.state.accordion[0]}
                    data-parent="#accordion"
                    id="collapseOne"
                    aria-labelledby="1"
                  >
                    <CardBody>
                      1. Anim pariatur cliche reprehenderit, enim eiusmod high
                      life accusamus terry richardson ad squid. 3 wolf moon
                      officia aute, non cupidatat skateboard dolor brunch. Food
                      truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                      tempor, sunt aliqua put a bird on it squid single-origin
                      coffee nulla assumenda shoreditch et. Nihil anim keffiyeh
                      helvetica, craft beer labore wes anderson cred nesciunt
                      sapiente ea proident. Ad vegan excepteur butcher vice
                      lomo. Leggings occaecat craft beer farm-to-table, raw
                      denim aesthetic synth nesciunt you probably haven't heard
                      of them accusamus labore sustainable VHS.
                    </CardBody>
                  </Collapse> */}
                </div>
              </div>
            </div>
            <div>
              {/* <CardHeader>
                <i className="fa fa-align-justify"></i> Collapse{" "}
                <small>accordion</small>
                <div className="card-header-actions">
                  <Badge>NEW</Badge>
                </div>
              </CardHeader> */}

              <div id="accordion">
                <div>
                  <CardHeader id="1">
                    <Button
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => this.toggleAccordion(0)}
                      aria-expanded={this.state.accordion[0]}
                      aria-controls="collapseOne"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <Row className="justify-content-around text-center ">
                        <Col xs="1">1</Col>
                        <Col xs="1">12345</Col>
                        <Col xs="2">Counseling</Col>
                        <Col xs="2">02-06-2019</Col>
                        <Col xs="3">02-06-2019 at 10:20 AM</Col>
                        <Col xs="1">Clinic</Col>
                        <Col xs="1">Booked</Col>
                        <Col xs="1">
                          {this.state.accordion[0] ? (
                            <i class="fa fa-angle-down"></i>
                          ) : (
                            <i class="fa fa-angle-up"></i>
                          )}
                        </Col>
                      </Row>
                    </Button>
                  </CardHeader>
                  <Collapse
                    isOpen={this.state.accordion[0]}
                    data-parent="#accordion"
                    id="collapseOne"
                    aria-labelledby="1"
                  >
                    <CardBody>
                      <Row>
                        <Col xs="6">
                          {/* 1st */}
                          <Row className="justify-content-center mb-2">
                            <strong>Vishal Deep Verma</strong>
                          </Row>
                          <Row>
                            {/* 1st */}
                            <Col xs="6">
                              <Row xs="12" className="justify-content-center">
                                <img
                                  style={{ width: "5rem" }}
                                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ8OMh7aruODZeEJOAPEW8pmb_KPx8KC0QzODoV1nTKGmq8t-3F"
                                  alt=""
                                ></img>
                              </Row>
                              <Row xs="12" className="justify-content-center">
                                <Button color="link">
                                  <small>Service Feedback</small>
                                </Button>
                              </Row>
                            </Col>
                            {/* 2nd */}
                            <Col xs="6" style={{ fontSize: "0.8rem" }}>
                              <Row xs="12" className="mb-0">
                                Counseling
                              </Row>
                              <Row xs="12">
                                <div>1. details of Service booked</div>
                                <div>2. details of Service booked</div>
                                <div>3. details of Service booked</div>

                                <Button color="link">
                                  <small>Service Feedback</small>
                                </Button>
                              </Row>
                            </Col>
                          </Row>
                        </Col>

                        {/* 2nd */}
                        <Col xs="6">
                          {/* 1st */}
                          <Row className="justify-content-center mb-2">
                            <strong>Payment Summary</strong>
                          </Row>
                          <Row style={{ fontSize: "0.8rem" }}>
                            {/* 1st */}
                            <Col xs="12">
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>Booking Amount</span>
                                    </Col>
                                    <Col xs="6">
                                      <span>Rs.300</span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>Invoice Amount</span>
                                    </Col>
                                    <Col xs="6">
                                      <span>Rs.300</span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>
                                        <strong>Amount Paid</strong>
                                      </span>
                                    </Col>
                                    <Col xs="6">
                                      <span>
                                        <strong>Rs.600</strong>
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>
                                        <Button color="link" size="sm">
                                          <small>Download Invoice</small>
                                        </Button>
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>
                                        <Button color="success" size="sm">
                                          Reschedule
                                        </Button>
                                      </span>
                                    </Col>
                                    <Col xs="6">
                                      <Button color="danger" size="sm">
                                        Cancel
                                      </Button>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Collapse>
                </div>
              </div>
            </div>
            <div>
              {/* <CardHeader>
                <i className="fa fa-align-justify"></i> Collapse{" "}
                <small>accordion</small>
                <div className="card-header-actions">
                  <Badge>NEW</Badge>
                </div>
              </CardHeader> */}

              <div id="accordion">
                <div>
                  <CardHeader id="1">
                    <Button
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => this.toggleAccordion(1)}
                      aria-expanded={this.state.accordion[1]}
                      aria-controls="collapseOne"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <Row className="justify-content-around text-center ">
                        <Col xs="1">2</Col>
                        <Col xs="1">12345</Col>
                        <Col xs="2">Ultrasonography</Col>
                        <Col xs="2">02-06-2019</Col>
                        <Col xs="3">02-06-2019 at 10:20 AM</Col>
                        <Col xs="1">Clinic</Col>
                        <Col xs="1">Booked</Col>
                        <Col xs="1">
                          {this.state.accordion[1] ? (
                            <i class="fa fa-angle-down"></i>
                          ) : (
                            <i class="fa fa-angle-up"></i>
                          )}
                        </Col>
                      </Row>
                    </Button>
                  </CardHeader>
                  <Collapse
                    isOpen={this.state.accordion[1]}
                    data-parent="#accordion"
                    id="collapseOne"
                    aria-labelledby="1"
                  >
                    <CardBody>
                    <Row>
                        <Col xs="6">
                          {/* 1st */}
                          <Row className="justify-content-center mb-2">
                            <strong>Vishal Deep Verma</strong>
                          </Row>
                          <Row>
                            {/* 1st */}
                            <Col xs="6">
                              <Row xs="12" className="justify-content-center">
                                <img
                                  style={{ width: "5rem" }}
                                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ8OMh7aruODZeEJOAPEW8pmb_KPx8KC0QzODoV1nTKGmq8t-3F"
                                  alt=""
                                ></img>
                              </Row>
                              <Row xs="12" className="justify-content-center">
                                <Button color="link">
                                  <small>Service Feedback</small>
                                </Button>
                              </Row>
                            </Col>
                            {/* 2nd */}
                            <Col xs="6" style={{ fontSize: "0.8rem" }}>
                              <Row xs="12" className="mb-0">
                                Counseling
                              </Row>
                              <Row xs="12">
                                <div>1. details of Service booked</div>
                                <div>2. details of Service booked</div>
                                <div>3. details of Service booked</div>

                                <Button color="link">
                                  <small>Service Feedback</small>
                                </Button>
                              </Row>
                            </Col>
                          </Row>
                        </Col>

                        {/* 2nd */}
                        <Col xs="6">
                          {/* 1st */}
                          <Row className="justify-content-center mb-2">
                            <strong>Payment Summary</strong>
                          </Row>
                          <Row style={{ fontSize: "0.8rem" }}>
                            {/* 1st */}
                            <Col xs="12">
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>Booking Amount</span>
                                    </Col>
                                    <Col xs="6">
                                      <span>Rs.300</span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>Invoice Amount</span>
                                    </Col>
                                    <Col xs="6">
                                      <span>Rs.300</span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>
                                        <strong>Amount Paid</strong>
                                      </span>
                                    </Col>
                                    <Col xs="6">
                                      <span>
                                        <strong>Rs.600</strong>
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>
                                        <Button color="link" size="sm">
                                          <small>Download Invoice</small>
                                        </Button>
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row xs="12" className="justify-content-end">
                                <Col xs="6">
                                  <Row xs="12">
                                    <Col xs="6">
                                      <span>
                                        <Button color="success" size="sm">
                                          Reschedule
                                        </Button>
                                      </span>
                                    </Col>
                                    <Col xs="6">
                                      <Button color="danger" size="sm">
                                        Cancel
                                      </Button>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Collapse>
                </div>
              </div>
            </div>
            <div>
              {/* <CardHeader>
                <i className="fa fa-align-justify"></i> Collapse{" "}
                <small>accordion</small>
                <div className="card-header-actions">
                  <Badge>NEW</Badge>
                </div>
              </CardHeader> */}

              <div id="accordion">
                <div>
                  <CardHeader id="2">
                    <Button
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => this.toggleAccordion(2)}
                      aria-expanded={this.state.accordion[2]}
                      aria-controls="collapseOne"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <Row className="justify-content-around text-center ">
                        <Col xs="1">3</Col>
                        <Col xs="1">12345</Col>
                        <Col xs="2">Ultrasonography</Col>
                        <Col xs="2">02-06-2019</Col>
                        <Col xs="3">02-06-2019 at 10:20 AM</Col>
                        <Col xs="1">Online</Col>
                        <Col xs="1">Completed</Col>
                        <Col xs="1">
                          {this.state.accordion[2] ? (
                            <i class="fa fa-angle-down"></i>
                          ) : (
                            <i class="fa fa-angle-up"></i>
                          )}
                        </Col>
                      </Row>
                    </Button>
                  </CardHeader>
                  <Collapse
                    isOpen={this.state.accordion[2]}
                    data-parent="#accordion"
                    id="collapseOne"
                    aria-labelledby="1"
                  >
                    <CardBody>
                      <Row>
                        <Col xs="6">
                          {/* 1st */}
                          <Row className="justify-content-center mb-2">
                            <strong>Vishal Deep Verma</strong>
                          </Row>
                          <Row>
                            {/* 1st */}
                            <Col xs="6">
                              <Row xs="12" className="justify-content-center">
                                <img
                                  style={{ width: "5rem" }}
                                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ8OMh7aruODZeEJOAPEW8pmb_KPx8KC0QzODoV1nTKGmq8t-3F"
                                  alt=""
                                ></img>
                              </Row>
                              <Row xs="12" className="justify-content-center">
                                <Button color="link">
                                  <small>Service Feedback</small>
                                </Button>
                              </Row>
                            </Col>
                            {/* 2nd */}
                            <Col xs="6" style={{ fontSize: "0.8rem" }}>
                              <Row xs="12" className="mb-0">
                                Counseling
                              </Row>
                              <Row xs="12">
                                <div>1. details of Service booked</div>
                                <div>2. details of Service booked</div>
                                <div>3. details of Service booked</div>

                                <Button color="link">
                                  <small>Service Feedback</small>
                                </Button>
                              </Row>
                            </Col>
                          </Row>
                        </Col>

                        {/* 2nd */}
                        <Col xs="6">
                          <Row className="justify-content-center mb-2">
                            <strong>Payment Summary</strong>
                          </Row>
                          <Row></Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Collapse>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Collapses;



// WEBPACK FOOTER //
// ./src/views/BookedServices/ServiceBookings/Collapse.jsx